export function base64EncodeUrlSafe(str: string): string {
	const encoder = new TextEncoder();
	const data = encoder.encode(str);

	const binaryString = String.fromCharCode(...data);
	return btoa(binaryString).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function decodeUrlSafeBase64(encoded: string): string | null {
	try {
		const base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
		const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
		const binary = atob(padded);
		const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
		return new TextDecoder().decode(bytes);
	} catch {
		return null;
	}
}
